const CURRENCIES = {
    usd: {
        id: 'usd',
        netsuiteId: '1',
        symbol: '$',
        code: 'USD',
        name: 'US Dollar',        
    },
    gbp: {
        id: 'gbp',
        netsuiteId: '2',
        symbol: '£',
        code: 'GBP',
        name: 'British Pound',        
    },
    eur: {
        id: 'eur',
        netsuiteId: '4',
        symbol: '€',
        code: 'EUR',
        name: 'Euro',        
    },   
    cad: {
        id: 'cad',
        netsuiteId: '3',
        symbol: 'C$',
        code: 'CAD',
        name: 'Canadian Dollar',        
    },    
    mxn: {
        id: 'mxn',
        netsuiteId: '5',
        symbol: 'Mex$',
        code: 'MXN',
        name: 'Mexican Peso',        
    },        
}

export {
    CURRENCIES,
}


// WEBPACK FOOTER //
// ./src/constants/currencies.js